export default "__VITE_ASSET__064800f2__"